import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'happy-control-group-input',
  templateUrl: './happy-control-group-input.component.html',
  styleUrls: ['./happy-control-group-input.component.css', '../styles.css']
})
export class HappyControlGroupInputComponent implements OnInit {
  @Input() required = true;

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-control-group/happy-control-group-input.component.ts